new Vue({
    el:'.material',
    data(){
        return {
            // 加载完成
            loadFlag:false,
            nav:[
                {
                    title:'Brand Materials',
                    children:['IP Merchandise','Apparel & Bags','Other Brand Gifts']
                },
                {
                    title:'Retail Channel',
                    // 'Basic Product'
                    children:['Flagship Store','Standard Store','Roadshow']
                }
            ],
            cartFlag:false,
            navIndex:0,
            navChildIndex:0,
            data:[
                [
                    [
                        {
                            name:'OXVA MOMO Cushion',
                            cName:'OXVA IP抱枕',
                            num:0,
                            img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/OXVA-MOMO-Character-Cushion.avif?v=1779071136'
                        },
                        {
                            name:'OXVA MOMO Plush Keychain',
                            cName:'OXVA 品牌款毛绒钥匙扣',
                            num:0,
                            img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/OXVA-MOMO-Plush-Keychain.avif?v=1775119798'
                        },
                        {
                            name:'OXVA MOMO Keychain',
                            cName:'OXVA IP钥匙扣',
                            num:0,
                            img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/OXVA-MOMO-Keychain.avif?v=1775119798'
                        },
                        {
                            name:'OXVA MOMO Phone Stand',
                            cName:'OXVA MOMO 手机支架',
                            num:0,
                            img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/OXVA-MOMO-Phone-Stand.avif?v=1775119798'
                        },
                        {
                            name:'OXVA MOMO Beer Bottle Opener',
                            cName:'OXVA MOMO啤酒开瓶器',
                            num:0,
                            img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/OXVA-MOMO-Beer-Bottle-Opener.avif?v=1775119798'
                        },
                        {
                            name:'OXVA MOMO Coaster',
                            cName:'OXVA IP杯垫',
                            num:0,
                            img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/OXVA-MOMO-Character-Coaster.avif?v=1779071136'
                        },
                        {
                            name:'OXVA MOMO Luggage Tag',
                            cName:'OXVA 行李牌',
                            num:0,
                            img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/OXVA-MOMO-Luggage-Tag.avif?v=1775119798'
                        },
                        {
                            name:'OXVA MOMO Phone Strap',
                            cName:'OXVA MOMO 手机链',
                            num:0,
                            img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/OXVA-MOMO-Phone-Strap.avif?v=1786517654'
                        },
                        {
                            name:'OXVA MOMO Sticky Notes',
                            cName:'OXVA 便签纸',
                            num:0,
                            img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/OXVA-MOMO-Sticky-Notes.avif?v=1779071136'
                        }
                    ],
                    [
                        {
                            name:'OXVA T-shirt (Black)',
                            cName:'OXVA 全球版T恤',
                            num:0,
                            img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/OXVA-T-shirt-Black.avif?v=1775119918'
                        },
                        {
                            name:'OXVA T-shirt (White)',
                            cName:'OXVA 全球版T恤',
                            num:0,
                            img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/OXVA-T-shirt-White.avif?v=1775119918'
                        },
                        {
                            name:'OXVA Vest (Black)',
                            cName:'OXVA 品牌马甲',
                            num:0,
                            img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/OXVA-Vest-Black.avif?v=1779071136'
                        },
                        {
                            name:'OXVA Hoodie (Black)',
                            cName:'OXVA 2025年全球版卫衣 ',
                            num:0,
                            img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/OXVA-Hoodie-Black.avif?v=1775119918'
                        },
                        {
                            name:'OXVA Hoodie (White)',
                            cName:'OXVA 2025年全球版卫衣 ',
                            num:0,
                            img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/OXVA-Hoodie-White.avif?v=1775119918'
                        },
                        {
                            name:'OXVA Cap',
                            cName:'OXVA 品牌鸭舌帽',
                            num:0,
                            img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/OXVA-Cap.avif?v=1775119918'
                        },
                        {
                            name:'OXVA Bucket Hat',
                            cName:'OXVA 渔夫帽（德国版）',
                            num:0,
                            img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/OXVA-Bucket-Hat-_DE-Version.avif?v=1775119918'
                        },
                        {
                            name:'OXVA Sun Hat',
                            cName:'OXVA 遮阳帽',
                            num:0,
                            img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/OXVA-Sun-Hat.avif?v=1775119918'
                        },
                        {
                            name:'OXVA Cuffed Beanie',
                            cName:'OXVA 品牌版毛线帽',
                            num:0,
                            img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/OXVA-Cuffed-Beanie.avif?v=1779071136'
                        },
                        {
                            name:'OXVA Leather Label Glove',
                            cName:'OXVA 皮标手套（波兰版）',
                            num:0,
                            img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/OXVA-Leather-Label-Glove-_PL-Version.avif?v=1775119918'
                        },
                        {
                            name:'OXVA Brand Backpack',
                            cName:'OXVA 品牌版双肩包',
                            num:0,
                            img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/OXVA-Brand-Backpack.avif?v=1775119918'
                        },
                        {
                            name:'OXVA Brand Multi-Functional Backpack',
                            cName:'OXVA 品牌多功能背包',
                            num:0,
                            img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/OXVA-Brand-Multi-Functional-Backpack.avif?v=1775119918'
                        },
                        {
                            name:'OXVA Foldable Travel Backpack',
                            cName:'OXVA 可折叠旅行背包',
                            num:0,
                            img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/OXVA-Foldable-Travel-Backpack.avif?v=1775119918'
                        },
                        {
                            name:'OXVA Canvas Bag (White)',
                            cName:'OXVA 品牌版帆布袋',
                            num:0,
                            img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/OXVA-Canvas-Bag_White.avif?v=1786517654'
                        },
                        {
                            name:'OXVA Canvas Bag (Black)',
                            cName:'OXVA 品牌版帆布袋',
                            num:0,
                            img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/OXVA-Canvas-Bag_Black.avif?v=1786517654'
                        },
                        {
                            name:'OXVA Woven Bag',
                            cName:'OXVA 品牌款编织袋',
                            num:0,
                            img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/OXVA-Woven-Bag.avif?v=1779071136'
                        },
                        {
                            name:'OXVA MOMO Drawstring Backpack',
                            cName:'OXVA MOMO 抽绳背包',
                            num:0,
                            img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/OXVA-MOMO-Drawstring-Backpack.avif?v=1775119918'
                        },
                        {
                            name:'OXVA Passport Crossbody Bag',
                            cName:'OXVA 护照斜挎包（波兰版）',
                            num:0,
                            img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/OXVA-Passport-Crossbody-Bag_PL-Version.avif?v=1775119918'
                        },
                        {
                            name:'OXVA Foldable Sunglass',
                            cName:'OXVA 可折叠太阳镜',
                            num:0,
                            img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/OXVA-Foldable-Sunglass.avif?v=1779071136'
                        },
                        {
                            name:'OXVA Card Holder',
                            cName:'OXVA 卡包（俄罗斯版）',
                            num:0,
                            img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/OXVA-Card-Holder.avif?v=1779071136'
                        },
                        {
                            name:'OXVA Card Pouch',
                            cName:'OXVA 品牌版卡包',
                            num:0,
                            img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/OXVA-Card-Pouch.avif?v=1779071136'
                        }
                    ],
                    [
                        {
                            name:'OXVA Bluetooth Speaker (Black)',
                            cName:'OXVA蓝牙音响',
                            num:0,
                            img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/OXVA-Bluetooth-Speaker_Black.avif?v=1786517654'
                        },
                        {
                            name:'OXVA Bluetooth Speaker (red)',
                            cName:'OXVA蓝牙音响',
                            num:0,
                            img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/OXVA-Bluetooth-Speaker_Red.avif?v=1786517654'
                        },
                        {
                            name:'OXVA Umbrella',
                            cName:'OXVA 品牌版双人雨伞',
                            num:0,
                            img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/OXVA-Umbrella.avif?v=1775120688'
                        },
                        {
                            name:'OXVA Luminous Fan',
                            cName:'OXVA 发光风扇',
                            num:0,
                            img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/OXVA-Luminous-Fan.avif?v=1775120688'
                        },
                        {
                            name:'OXVA Lanyard',
                            cName:'OXVA 挂绳',
                            num:0,
                            img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/OXVA-Lanyard.avif?v=1775120688'
                        },
                        {
                            name:'OXVA Adjustable Vape Lanyard',
                            cName:'OXVA 可调节烟杆挂绳',
                            num:0,
                            img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/OXVA-Adjustable-Vape-Lanyard.avif?v=1779071136'
                        },
                        {
                            name:'OXVA 2-in-2 Charging Cable',
                            cName:'OXVA 二托二数据线',
                            num:0,
                            img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/OXVA-2-in-2-Charging-Cable.avif?v=1775120688'
                        },
                        {
                            name:'OXVA Tape',
                            cName:'OXVA 品牌版封箱胶带',
                            num:0,
                            img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/OXVA-Tape_b83c49e1-07a7-49ed-b7c1-8f058b46ef07.avif?v=1779074928'
                        },
                        {
                            name:'OXVA Magnetic Phone Card Holder Stand',
                            cName:'OXVA 手机磁吸卡包支架',
                            num:0,
                            img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/OXVA-Magnetic-Phone-Card-Holder-Stand.avif?v=1779074927'
                        },
                        {
                            name:'OXVA Pod Pouch',
                            cName:'OXVA 烟弹收纳袋',
                            num:0,
                            img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/OXVA-Pod-Pouch.avif?v=1779071136'
                        },
                        {
                            name:'OXVA Badge',
                            cName:'OXVA 徽章',
                            num:0,
                            img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/OXVA-Badge.avif?v=1779071136'
                        },
                        {
                            name:'OXVA Travel Tumbler',
                            cName:'OXVA 保温杯',
                            num:0,
                            img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/OXVA-Travel-Tumbler.avif?v=1779071135'
                        }
                    ]
                ],
                [
                    [
                        {
                            name:'OXVA In-Store Stickers',
                            type:'Store Exterior',
                            cName:'OXVA 门店在售贴纸',
                            num:0,
                            img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/OXVA_In-Store_Stickers.avif?v=1775530361'
                        },
                        {
                            name:'OXVA Storefront Graffiti',
                            type:'Store Exterior',
                            cName:'OXVA 门店涂鸦',
                            num:0,
                            img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/OXVA_Storefront_Graffiti.avif?v=1775530361'
                        },
                        {
                            name:'OXVA Open&Closed Sign',
                            type:'Store Exterior',
                            cName:'OXVA 亚克力开关门挂牌',
                            num:0,
                            img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/OXVA-Open_Closed-Sign.avif?v=1775556579'
                        },
                        {
                            name:'OXVA Push&Pull Sticker(MOMO Ver.)',
                            type:'Store Exterior',
                            cName:'OXVA Push&Pull 门贴贴纸',
                            num:0,
                            img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/OXVA-Push_Pull-Door-Sticker_MOMO-Version.avif?v=1775556579'
                        },
                        {
                            name:'OXVA Push&Pull Sticker(Regular Ver.)',
                            type:'Store Exterior',
                            cName:'OXVA Push&Pull 贴纸（无MOMO图案）',
                            num:0,
                            img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/OXVA-Push_Pull-Door-Sticker_Regular-Version.avif?v=1775556579'
                        },
                        {
                            name:'OXVA LOGO Window Sticker',
                            type:'Store Exterior',
                            cName:'OXVA LOGO 窗贴',
                            num:0,
                            img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/OXVA_LOGO_Window_Sticker.avif?v=1775530361'
                        },
                        {
                            name:'OXVA Glass Door Sticker',
                            type:'Store Exterior',
                            cName:'OXVA 品牌logo玻璃门腰线贴纸',
                            num:0,
                            img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/OXVA_Glass_Door_Sticker.avif?v=1775530361'
                        },
                        {
                            name:'OXVA Feather Flag',
                            type:'Store Exterior',
                            cName:'OXVA 刀旗',
                            num:0,
                            img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/OXVA_Feather_Flag.avif?v=1775530361'
                        },
                        {
                            name:'Store Signage',
                            type:'Store Exterior',
                            cName:'店铺门头',
                            num:0,
                            img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/Store_Signage.avif?v=1775530361'
                        },
                        {
                            name:'OXVA Flagship Store Lightbox',
                            type:'Store Exterior',
                            cName:'OXVA 标杆店铺灯箱',
                            num:0,
                            img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/OXVA_Flagship_Store_Lightbox.avif?v=1775530361'
                        },
                        {
                            name:'OXVA Storefront Floor Standing Sign',
                            type:'Store Exterior',
                            cName:'OXVA 门店落地广告牌',
                            num:0,
                            img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/OXVA_Storefront_Floor_Standing_Sign.avif?v=1775530635'
                        },
                        {
                            name:'OXVA Authorized Store Sticker',
                            type:'Store Exterior',
                            cName:'OXVA 品牌授权门店贴纸',
                            num:0,
                            img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/OXVA-Authorized-Store-Sticker.avif?v=1779071136'
                        },
                        {
                            name:'OXVA Acrylic Trial Station',
                            type:'In-Store Display',
                            cName:'OXVA 亚克力试抽台',
                            num:0,
                            img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/OXVA_Acrylic_Trial_Station.avif?v=1775530636'
                        },
                        {
                            name:'OXVA Cabinet Graphic Sticker',
                            type:'In-Store Display',
                            cName:'OXVA 橱柜大贴纸',
                            num:0,
                            img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/OXVA_Cabinet_Graphic_Sticker.avif?v=1775530635'
                        },
                        {
                            name:'OXVA Acrylic LOGO Letters',
                            type:'In-Store Display',
                            cName:'OXVA 亚克力立体字',
                            num:0,
                            img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/OXVA_Acrylic_LOGO_Letters.avif?v=1775530636'
                        },
                        {
                            name:'OXVA Cardboard Display Stand',
                            type:'In-Store Display',
                            cName:'OXVA 纸质展示架',
                            num:0,
                            img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/OXVA_Cardboard_Display_Stand.avif?v=1775530636'
                        },
                        {
                            name:'OXVA LOGO Shelf Sticker',
                            type:'In-Store Display',
                            cName:'OXVA LOGO 货架标签贴',
                            num:0,
                            img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/OXVA_LOGO_Shelf_Sticker.avif?v=1775530636'
                        },
                        {
                            name:'OXVA Product Holder',
                            type:'In-Store Display',
                            cName:'OXVA 产品支架',
                            num:0,
                            img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/OXVA_Product_Holder.avif?v=1775530636'
                        },
                        {
                            name:'OXVA Floor Mat',
                            type:'In-Store Display',
                            cName:'OXVA 标杆门店地垫',
                            num:0,
                            img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/OXVA-Floor-Mat.avif?v=1779071136'
                        },
                        {
                            name:'OXVA POP Display',
                            type:'In-Store Display',
                            cName:'OXVA 小型产品展示柜',
                            num:0,
                            img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/OXVA-POP-Display.avif?v=1779071135'
                        },
                        {
                            name:'OXVA Acrylic Display Stand',
                            type:'In-Store Display',
                            cName:'OXVA 亚克力展示架',
                            num:0,
                            img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/OXVA_Acrylic_Display_Stand.avif?v=1775530635'
                        },
                        {
                            name:'OXVA Cardboard Trial Station',
                            type:'In-Store Display',
                            cName:'OXVA 纸质试抽台',
                            num:0,
                            img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/OXVA_Cardboard_Trial_Station.avif?v=1775530635'
                        },
                        {
                            name:'OXVA Light Signs',
                            type:'In-Store Display',
                            cName:'OXVA 新款灯牌',
                            num:0,
                            img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/OXVA_Light_Signs.avif?v=1775530635'
                        },
                        {
                            name:'OXVA 2-Tier Display Cabinet',
                            type:'In-Store Display',
                            cName:'OXVA 双层产品展示柜',
                            num:0,
                            img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/OXVA_2-Tier_Display_Cabinet.avif?v=1775556579'
                        },
                        {
                            name:'OXVA 3-Tier Display Cabinet',
                            type:'In-Store Display',
                            cName:'OXVA 三层产品展示柜',
                            num:0,
                            img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/OXVA_3-Tier_Display_Cabinet.avif?v=1775556579'
                        },
                        {
                            name:'OXVA Roll-up Banner',
                            type:'In-Store Display',
                            cName:'OXVA 易拉宝',
                            num:0,
                            img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/OXVA_Roll-up_Banner.avif?v=1775530635'
                        },
                        {
                            name:'OXVA Store Authorization Certificate',
                            type:'In-Store Display',
                            cName:'OXVA 门店授权书',
                            num:0,
                            img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/OXVA_Store_Authorization_Certificate.avif?v=1775530635'
                        },
                        {
                            name:'OXVA Tabletop Display Card',
                            type:'In-Store Display',
                            cName:'OXVA 桌面台卡',
                            num:0,
                            img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/OXVA_Tabletop_Display_Card.avif?v=1775530635'
                        },
                        {
                            name:'OXVA Branded Display Counter',
                            type:'In-Store Display',
                            cName:'OXVA 专柜',
                            num:0,
                            img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/OXVA_Branded_Display_Counter.avif?v=1775530636'
                        },
                        {
                            name:'OXVA Mouse Pad',
                            type:'In-Store Display',
                            cName:'OXVA 鼠标垫',
                            num:0,
                            img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/OXVA_Mouse_Pad.avif?v=1775530635'
                        },
                        {
                            name:'OXVA Cabinet Graphic Sticker',
                            type:'In-Store Display',
                            cName:'OXVA 橱柜大贴纸',
                            num:0,
                            img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/OXVA_Cabinet_Graphic_Sticker.avif?v=1775530635'
                        },
                        {
                            name:'OXVA Shopping Bag',
                            type:'Store Essentials',
                            cName:'OXVA&OX Passion手提塑料袋（100pcs/包）',
                            num:0,
                            img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/OXVA_Shopping_Bag.avif?v=1775531208'
                        },
                        {
                            name:'OXVA Basic Product Marketing Materials',
                            type:'Store Essentials',
                            cName:'产品基本物料',
                            num:0,
                            img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/OXVA_Basic_Product_Marketing_Materials.avif?v=1775531208'
                        },
                        {
                            name:'OXVA Branded Notebook',
                            type:'Store Essentials',
                            cName:'OXVA 品牌版记事本',
                            num:0,
                            img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/OXVA_Branded_Notebook.avif?v=1775531208'
                        },
                        {
                            name:'OXVA Coin Tray',
                            type:'Store Essentials',
                            cName:'OXVA 零钱盘',
                            num:0,
                            img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/OXVA_Coin_Tray.avif?v=1775531208'
                        },
                        {
                            name:'OXVA Store Cushion',
                            type:'Store Essentials',
                            cName:'OXVA 标杆门店抱枕 （德国版）',
                            num:0,
                            img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/OXVA_Store_Cushion.avif?v=1775531208'
                        }
                    ],
                    [
                        {
                            name:'OXVA Authorized Store Sticker',
                            type:'Store Exterior',
                            cName:'OXVA 品牌授权门店贴纸',
                            num:0,
                            img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/OXVA-Authorized-Store-Sticker.avif?v=1779071136'
                        },
                        {
                            name:'OXVA In-Store Stickers',
                            type:'Store Exterior',
                            cName:'OXVA 门店在售贴纸',
                            num:0,
                            img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/OXVA_In-Store_Stickers.avif?v=1775530361'
                        },
                        {
                            name:'OXVA Open&Closed Sign',
                            type:'Store Exterior',
                            cName:'OXVA 亚克力开关门挂牌',
                            num:0,
                            img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/OXVA-Open_Closed-Sign.avif?v=1775556579'
                        },
                        {
                            name:'OXVA Push&Pull Sticker(MOMO Ver.)',
                            type:'Store Exterior',
                            cName:'OXVA Push&Pull 门贴贴纸',
                            num:0,
                            img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/OXVA-Push_Pull-Door-Sticker_MOMO-Version.avif?v=1775556579'
                        },
                        {
                            name:'OXVA Push&Pull Sticker(Regular Ver.)',
                            type:'Store Exterior',
                            cName:'OXVA Push&Pull 贴纸（无MOMO图案）',
                            num:0,
                            img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/OXVA-Push_Pull-Door-Sticker_Regular-Version.avif?v=1775556579'
                        },
                        {
                            name:'OXVA LOGO Window Sticker',
                            type:'Store Exterior',
                            cName:'OXVA LOGO 窗贴',
                            num:0,
                            img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/OXVA_LOGO_Window_Sticker.avif?v=1775530361'
                        },
                        {
                            name:'OXVA Glass Door Sticker',
                            type:'Store Exterior',
                            cName:'OXVA 玻璃门腰线贴',
                            num:0,
                            img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/OXVA_Glass_Door_Sticker.avif?v=1775530361'
                        },
                        {
                            name:'OXVA Acrylic LOGO Letters',
                            type:'In-Store Display',
                            cName:'OXVA 亚克力立体字',
                            num:0,
                            img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/OXVA_Acrylic_LOGO_Letters.avif?v=1775530636'
                        },
                        {
                            name:'OXVA Cardboard Display Stand',
                            type:'In-Store Display',
                            cName:'OXVA 纸质展示架',
                            num:0,
                            img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/OXVA_Cardboard_Display_Stand.avif?v=1775530636'
                        },
                        {
                            name:'OXVA Light Signs',
                            type:'In-Store Display',
                            cName:'OXVA 新款灯牌',
                            num:0,
                            img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/OXVA_Light_Signs.avif?v=1775530635'
                        },
                        {
                            name:'OXVA LOGO Shelf Sticker',
                            type:'In-Store Display',
                            cName:'OXVA LOGO 货架标签贴',
                            num:0,
                            img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/OXVA_LOGO_Shelf_Sticker.avif?v=1775530636'
                        },
                        {
                            name:'OXVA Mouse Pad',
                            type:'In-Store Display',
                            cName:'OXVA 鼠标垫',
                            num:0,
                            img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/OXVA_Mouse_Pad.avif?v=1775530635'
                        },
                        {
                            name:'OXVA Product Holder',
                            type:'In-Store Display',
                            cName:'OXVA 产品支架',
                            num:0,
                            img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/OXVA_Product_Holder.avif?v=1775530636'
                        },
                        {
                            name:'OXVA Floor Mat',
                            type:'In-Store Display',
                            cName:'OXVA 标杆门店地垫',
                            num:0,
                            img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/OXVA-Floor-Mat.avif?v=1779071136'
                        },
                        {
                            name:'OXVA Tabletop Display Card',
                            type:'In-Store Display',
                            cName:'OXVA 桌面台卡',
                            num:0,
                            img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/OXVA_Tabletop_Display_Card.avif?v=1775530635'
                        },
                        {
                            name:'OXVA Basic Product Marketing Materials',
                            type:'Store Essentials',
                            cName:'产品基本物料',
                            num:0,
                            img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/OXVA_Basic_Product_Marketing_Materials.avif?v=1775531208'
                        },
                        {
                            name:'OXVA Coin Tray',
                            type:'Store Essentials',
                            cName:'OXVA 零钱盘',
                            num:0,
                            img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/OXVA_Coin_Tray.avif?v=1775531208'
                        },
                        {
                            name:'OXVA Shopping Bag',
                            type:'Store Essentials',
                            cName:'OXVA&OX Passion手提塑料袋（100pcs/包）',
                            num:0,
                            img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/OXVA_Shopping_Bag.avif?v=1775531208'
                        },
                        {
                            name:'OXVA Store Cushion',
                            type:'Store Essentials',
                            cName:'OXVA 标杆门店抱枕 （德国版）',
                            num:0,
                            img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/OXVA_Store_Cushion.avif?v=1775531208'
                        }
                    ],
                    [
                        {
                            name:'OXVA Promotional Booth Counter',
                            cName:'OXVA 路演促销台',
                            num:0,
                            img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/OXVA_Promotional_Booth_Counter.avif?v=1775535262'
                        },
                        {
                            name:'OXVA Acrylic Display Stand',
                            cName:'OXVA 方形展示架',
                            num:0,
                            img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/OXVA-Acrylic-Display-Stand_6e6d5225-4414-4893-af21-e2f80b927293.avif?v=1779075013'
                        },
                        {
                            name:'OXVA Round Acrylic Display Stand',
                            cName:'OXVA 圆形发光展示架',
                            num:0,
                            img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/OXVA-Acrylic-Display-Stand.avif?v=1779071136'
                        },
                        {
                            name:'OXVA Shopping Paper Bag',
                            cName:'OXVA 购物纸袋',
                            num:0,
                            img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/OXVA_Shopping_Paper_Bag.avif?v=1775535262'
                        },
                        {
                            name:'OXVA Gift Box Paper Bag',
                            cName:'OXVA 礼盒纸袋',
                            num:0,
                            img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/OXVA_Gift_Box_Paper_Bag.avif?v=1775535262'
                        },
                        {
                            name:'OXVA Branded Balloons',
                            cName:'OXVA 品牌活动气球',
                            num:0,
                            img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/OXVA_Branded_Balloons.avif?v=1775535262'
                        },
                        {
                            name:'OXVA Disposable Mouthpieces',
                            cName:'OXVA 一次性吸嘴',
                            num:0,
                            img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/OXVA_Disposable_Mouthpieces.avif?v=1775535262'
                        },
                        {
                            name:'OXVA Basic Product Marketing Materials',
                            cName:'产品基本物料',
                            num:0,
                            img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/OXVA_Basic_Product_Marketing_Materials.avif?v=1775531208'
                        }
                    ],
                    [
                        {
                            name:'OXVA LOGO Shelf Sticker',
                            cName:'OXVA LOGO 货架标签贴',
                            num:0,
                            img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/OXVA_LOGO_Shelf_Sticker.avif?v=1775530636'
                        },
                        {
                            name:'OXVA Promotional Standee',
                            cName:'OXVA 促销立牌',
                            num:0,
                            img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/OXVA_Promotional_Stand.avif?v=1775535987'
                        },
                        {
                            name:'OXVA Protective Case',
                            cName:'OXVA 产品皮套',
                            num:0,
                            img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/OXVA_Protective_Case.avif?v=1775535987'
                        },
                        {
                            name:'OXVA Wobbler',
                            cName:'OXVA 跳跳卡',
                            num:0,
                            img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/OXVA_Wobbler.avif?v=1775535986'
                        },
                        {
                            name:'OXVA Folded Leaflet',
                            cName:'OXVA 折页',
                            num:0,
                            img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/OXVA_Folded_Leaflet.avif?v=1775535986'
                        },
                        {
                            name:'OXVA Scratch Card Display Board',
                            cName:'OXVA 促销活动刮刮板',
                            num:0,
                            img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/OXVA_Scratch_Card_Display_Board.avif?v=1775535986'
                        },
                        {
                            name:'OXVA Laminated Flavor Card',
                            cName:'OXVA  过塑口味卡',
                            num:0,
                            img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/OXVA_Laminated_Flavor_Card.avif?v=1775535986'
                        },
                        {
                            name:'OXVA Product Leaflet',
                            cName:'OXVA 产品单页',
                            num:0,
                            img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/OXVA_Product_Leaflet.avif?v=1775535986'
                        },
                        {
                            name:'OXVA Display Standee',
                            cName:'OXVA 立牌',
                            num:0,
                            img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/OXVA_Display_Stand.avif?v=1775535986'
                        },
                        {
                            name:'OXVA New Arrival Shelf Sticker',
                            cName:'OXVA 货架上市贴',
                            num:0,
                            img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/OXVA_New_Arrival_Shelf_Sticker.avif?v=1775535986'
                        },
                        {
                            name:'OXVA After-sales Card',
                            cName:'OXVA 售后卡片',
                            num:0,
                            img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/OXVA_After-sales_Card.avif?v=1775535986'
                        },
                        {
                            name:'OXVA Custom Shape Standee',
                            cName:'OXVA 异形立牌',
                            num:0,
                            img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/OXVA_Custom_Shape_Stand.avif?v=1775535986'
                        },
                        {
                            name:'OXVA Product Cushion',
                            cName:'OXVA 产品抱枕',
                            num:0,
                            img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/OXVA_Product_Cushion.avif?v=1775535986'
                        },
                        {
                            name:'OXVA Price Tag Sticker',
                            cName:'OXVA 货架价签贴',
                            num:0,
                            img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/OXVA_Price_Tag_Sticker.avif?v=1775535985'
                        },
                        {
                            name:'OXVA Poster',
                            cName:'OXVA 海报',
                            num:0,
                            img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/OXVA_Poster.avif?v=1775535985'
                        },
                        {
                            name:'OXVA Product Hanging Strip',
                            cName:'OXVA 产品挂条',
                            num:0,
                            img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/OXVA_Product_Hanging_Strip.avif?v=1775535985'
                        },
                        {
                            name:'OXVA Window Sticker',
                            cName:'OXVA 窗贴',
                            num:0,
                            img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/OXVA_Window_Sticker.avif?v=1775535984'
                        },
                        {
                            name:'OXVA Product Catalogue',
                            cName:'OXVA 产品手册',
                            num:0,
                            img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/OXVA_Product_Catalogue.avif?v=1775535983'
                        }
                    ]
                ]
            ],
            cartArr:[],
            exporting: false,
            exportProgress: 0
        }
    },
    computed: {
        filteredList() {
            return this.findItems(this.data);
        },
        cartTotal() {
            let total = 0;
    
            this.data.forEach(nav => {
                nav.forEach(child => {
                    child.forEach(item => {
                        total += Number(item.num) || 0;
                    });
                });
            });
    
            if(total>99){
                total = '99+'
            }
            return total;
        }
    },
    methods: {
        groupByType(list) {
            const map = {}
    
            list.forEach((item, index) => {
                const key = item.type || 'Other'
                if (!map[key]) {
                    map[key] = []
                }
                map[key].push({
                    ...item,
                    _index: index
                })
            })
    
            return map
        },
        deleteAll() {
            this.data.forEach(nav => {
                nav.forEach(child => {
                    child.forEach(item => {
                        item.num = 0;
                    });
                });
            });
        },
        async exportExcelJS() {
            if (this.exporting) return;
        
            const list = this.filteredList;
        
            if (!list || !list.length) {
                alert('No data to export');
                return;
            }
        
            this.exporting = true;
            this.exportProgress = 0;
        
            try {
                const workbook = new ExcelJS.Workbook();
                const worksheet = workbook.addWorksheet('OXVA Material');
        
                worksheet.columns = [
                    { header: 'Major Category', key: 'level1', width: 24 },
                    { header: 'Medium Category', key: 'level2', width: 24 },
                    { header: 'Minor Category', key: 'level3', width: 24 },
                    { header: 'Image', key: 'image', width: 25 },
                    { header: 'Item Name', key: 'name', width: 36 },
                    { header: 'Quantity', key: 'count', width: 12 },
                    { header: 'CRM物料名称', key: 'cName', width: 36 }
                ];
        
                const headerRow = worksheet.getRow(1);
                headerRow.height = 24;
                headerRow.eachCell(cell => {
                    cell.font = { bold: true, size: 12 };
                    cell.alignment = {
                        vertical: 'middle',
                        horizontal: 'center'
                    };
                    cell.fill = {
                        type: 'pattern',
                        pattern: 'solid',
                        fgColor: { argb: 'FFF5F5F5' }
                    };
                });
        
                const totalSteps = list.length + 3;
                let currentStep = 0;
        
                const updateProgress = async () => {
                    this.exportProgress = Math.min(
                        100,
                        Math.round((currentStep / totalSteps) * 100)
                    );
                    await this.$nextTick();
                };
        
                for (let i = 0; i < list.length; i++) {
                    const item = list[i];
                    const rowNumber = i + 2;
        
                    worksheet.addRow({
                        level1: item.level1 || '',
                        level2: item.level2 || '',
                        level3: item.level3 || '',
                        image: '',
                        name: item.name || '',
                        count: item.count || 0,
                        cName: item.cName || ''
                    });
        
                    const row = worksheet.getRow(rowNumber);
                    row.height = 120;
        
                    ['A', 'B', 'C', 'E', 'F'].forEach(col => {
                        worksheet.getCell(`${col}${rowNumber}`).alignment = {
                            vertical: 'middle',
                            horizontal: col === 'F' ? 'center' : 'left',
                            wrapText: true
                        };
                    });
        
                    worksheet.getCell(`D${rowNumber}`).alignment = {
                        vertical: 'middle',
                        horizontal: 'center'
                    };
        
                    ['A', 'B', 'C'].forEach(col => {
                        worksheet.getCell(`${col}${rowNumber}`).fill = {
                            type: 'pattern',
                            pattern: 'solid',
                            fgColor: { argb: 'FFFAFAFA' }
                        };
                    });
        
                    if (item.img) {
                        try {
                            const base64 = await this.imageUrlToBase64(item.img);
                            const extension = this.getImageExtensionFromBase64(base64);
        
                            if (extension) {
                                const imageId = workbook.addImage({
                                    base64,
                                    extension
                                });
        
                                worksheet.addImage(imageId, {
                                    tl: { col: 3 + 0.15, row: (rowNumber - 1) + 0.15 },
                                    ext: { width: 120, height: 120 }
                                });
                            }
                        } catch (err) {
                            console.warn('Image load failed:', item.img, err);
                        }
                    }
        
                    currentStep++;
                    await updateProgress();
                }
        
                this.mergeSameCells(worksheet, list, 'level1', 'A');
                this.mergeSameCells(worksheet, list, 'level2', 'B');
                this.mergeSameCells(worksheet, list, 'level3', 'C');
        
                currentStep++;
                await updateProgress();
        
                worksheet.eachRow((row, rowNumber) => {
                    row.eachCell({ includeEmpty: true }, cell => {
                        cell.border = {
                            top: { style: 'thin', color: { argb: 'FFD9D9D9' } },
                            left: { style: 'thin', color: { argb: 'FFD9D9D9' } },
                            bottom: { style: 'thin', color: { argb: 'FFD9D9D9' } },
                            right: { style: 'thin', color: { argb: 'FFD9D9D9' } }
                        };
        
                        cell.alignment = cell.alignment || {};
                        cell.alignment.vertical = 'middle';
                    });
                });
        
                worksheet.views = [
                    { state: 'frozen', ySplit: 1 }
                ];
        
                currentStep++;
                await updateProgress();
        
                const buffer = await workbook.xlsx.writeBuffer();
        
                currentStep++;
                await updateProgress();
        
                const blob = new Blob(
                    [buffer],
                    { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }
                );
        
                saveAs(blob, 'OXVA_Material.xlsx');
        
                this.exportProgress = 100;
            } catch (error) {
                console.error(error);
                alert('XLSX export failed');
            } finally {
                setTimeout(() => {
                    this.exporting = false;
                    this.exportProgress = 0;
                }, 300);
            }
        },
        mergeSameCells(worksheet, list, field, colLetter) {
            if (!list || !list.length) return;
    
            const getGroupKey = (item) => {
                if (field === 'level1') {
                    return `${item.level1 || ''}`;
                }
    
                if (field === 'level2') {
                    return `${item.level1 || ''}__${item.level2 || ''}`;
                }
    
                if (field === 'level3') {
                    return `${item.level1 || ''}__${item.level2 || ''}__${item.level3 || ''}`;
                }
    
                return `${item[field] || ''}`;
            };
    
            let startRow = 2;
            let prevKey = getGroupKey(list[0]);
            let prevValue = list[0][field] || '';
    
            for (let i = 1; i <= list.length; i++) {
                const currentKey = i < list.length ? getGroupKey(list[i]) : null;
                const currentRow = i + 2;
    
                if (currentKey !== prevKey) {
                    const endRow = currentRow - 1;
    
                    if (startRow < endRow && prevValue !== '') {
                        worksheet.mergeCells(`${colLetter}${startRow}:${colLetter}${endRow}`);
                    }
    
                    if (startRow === endRow) {
                        worksheet.getCell(`${colLetter}${startRow}`).value = prevValue;
                    }
    
                    startRow = currentRow;
                    prevKey = currentKey;
                    prevValue = i < list.length ? (list[i][field] || '') : '';
                }
            }
    
            for (let row = 2; row <= list.length + 1; row++) {
                const cell = worksheet.getCell(`${colLetter}${row}`);
                cell.alignment = {
                    vertical: 'middle',
                    horizontal: 'left',
                    wrapText: true
                };
            }
        },
        async imageUrlToBase64(url) {
            const response = await fetch(url, {
                mode: 'cors'
            });
    
            if (!response.ok) {
                throw new Error('Image request failed');
            }
    
            const blob = await response.blob();
    
            return await new Promise((resolve, reject) => {
                const reader = new FileReader();
                reader.onloadend = () => resolve(reader.result);
                reader.onerror = reject;
                reader.readAsDataURL(blob);
            });
        },
        getImageExtensionFromBase64(base64) {
            if (!base64 || typeof base64 !== 'string') return '';
    
            if (base64.indexOf('data:image/png') === 0) return 'png';
            if (base64.indexOf('data:image/jpeg') === 0) return 'jpeg';
            if (base64.indexOf('data:image/jpg') === 0) return 'jpeg';
            if (base64.indexOf('data:image/gif') === 0) return 'gif';
            if (base64.indexOf('data:image/webp') === 0) return 'png';
    
            return '';
        },
        findItems(arr, path = [], result = []) {
            arr.forEach((item, i) => {
                const currentPath = [...path, i];
    
                if (Array.isArray(item)) {
                    this.findItems(item, currentPath, result);
                } else if (item && typeof item === 'object' && item.num > 0) {
                    const navIndex = currentPath[0];
                    const navChildIndex = currentPath[1];
    
                    result.push({
                        level1: this.nav[navIndex] ? this.nav[navIndex].title : '',
                        level2: this.nav[navIndex] && this.nav[navIndex].children
                            ? (this.nav[navIndex].children[navChildIndex] || '')
                            : '',
                        level3: item.type || '',
                        name: item.name || '',
                        count: item.num || 0,
                        img: item.img || '',
                        cName: item.cName || '',
                        type: item.type || '',
                        _path: currentPath
                    });
                }
            });
    
            return result;
        },
        deleteItem(path) {
            var [navIndex, navChildIndex, itemIndex] = path;
            this.data[navIndex][navChildIndex][itemIndex].num = 0;
        },
        chanceNumCart(id, path) {
            var [navIndex, navChildIndex, itemIndex] = path;
    
            if (id == 0) {
                if (this.data[navIndex][navChildIndex][itemIndex].num > 0) {
                    this.data[navIndex][navChildIndex][itemIndex].num--;
                }
            } else {
                this.data[navIndex][navChildIndex][itemIndex].num++;
            }
        },
        chanceNum(id, index) {
            if (id == 0) {
                if (this.data[this.navIndex][this.navChildIndex][index].num > 0) {
                    this.data[this.navIndex][this.navChildIndex][index].num--;
                }
            } else {
                this.data[this.navIndex][this.navChildIndex][index].num++;
            }
        }
    },
    mounted(){ 
        // 加载完成后 更新弹窗显示样式
        this.loadFlag = true
        //提前加载图片-------------------------------
        const preloadImages = () => {
            this.data.forEach(nav => {
                nav.forEach(child => {
                    child.forEach(item => {
                        const img = new Image();
                        img.src = item.img;
                    });
                });
            }); 
        };
        preloadImages()
    }
})